function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.858 16.188a2.8 2.8 0 011.767-.625 2.815 2.815 0 012.813 2.812 2.815 2.815 0 01-2.813 2.813 2.815 2.815 0 01-2.702-3.593l-4.613-3.34A3.749 3.749 0 013.562 12a3.749 3.749 0 016.748-2.255l4.613-3.34a2.815 2.815 0 012.702-3.593 2.815 2.815 0 012.813 2.813 2.815 2.815 0 01-2.813 2.813 2.8 2.8 0 01-1.767-.626l-4.856 3.513c.08.446.08.904 0 1.35l4.856 3.513z"
})));